import { memo } from 'react';
import { Mask as _Mask, Path as _Path, Rect as _Rect, Svg as _Svg } from 'react-native-svg';
import { themed } from './themed';

const Icon = (props) => {
  const { color, size } = props;
  return (
    <_Svg
      height={size}
      width={size}
      viewBox="0 0 251 207"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <_Path
        d="M241.572 99.1505L241.568 99.154L152.285 188.437L152.281 188.441V188.434V144.049V134.6L142.847 135.135C75.628 138.949 29.9018 182.372 17.1532 195.979L17.1514 195.981C16.5094 196.666 15.6675 197.132 14.7456 197.311C13.8236 197.491 12.8686 197.375 12.0163 196.98C11.1641 196.585 10.4581 195.932 9.99876 195.112C9.53946 194.293 9.35028 193.35 9.45813 192.417L9.45873 192.411C13.3023 158.99 31.6838 126.328 61.8996 100.691L61.8998 100.691C87.0353 79.3621 117.308 66.1116 144.114 63.8175L152.281 63.1186V54.9217L152.281 9.86702L152.281 9.85999L152.285 9.86351L241.568 99.1469L241.572 99.1505Z"
        stroke={color}
        strokeWidth="14"
        // strokeWidth="17.8567"
      />
    </_Svg>
  );
};
Icon.displayName = 'ShareRegular';
const ShareRegular = memo(themed(Icon));
export { ShareRegular };
